/*
 * ATTENTION: The "eval" devtool has been used (maybe by default in mode: "development").
 * This devtool is neither made for production nor for readable output files.
 * It uses "eval()" calls to create a separate source file in the browser devtools.
 * If you are trying to read the output file, select a different devtool (https://webpack.js.org/configuration/devtool/)
 * or disable the default devtool with "devtool: false".
 * If you are looking for production-ready output files, see mode: "production" (https://webpack.js.org/configuration/mode/).
 */
/******/ (() => { // webpackBootstrap
/******/ 	"use strict";
/******/ 	var __webpack_modules__ = ({

/***/ "./src/scripts/templates/page.color-swatches.js":
/*!******************************************************!*\
  !*** ./src/scripts/templates/page.color-swatches.js ***!
  \******************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

eval("__webpack_require__.r(__webpack_exports__);\n/* harmony import */ var jquery__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! jquery */ \"jquery\");\n/* harmony import */ var jquery__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(jquery__WEBPACK_IMPORTED_MODULE_0__);\n\r\n\r\njquery__WEBPACK_IMPORTED_MODULE_0___default()(document).ready(function() {\r\n  var filteredProjects = [];\r\n  var selection = \"all\";\r\n  var running = false;\r\n  \r\n  jquery__WEBPACK_IMPORTED_MODULE_0___default()(window).resize(function() {\r\n    buildGrid(filteredProjects);\r\n  });\r\n\r\n  jquery__WEBPACK_IMPORTED_MODULE_0___default()('.color-swatch__category-buttons a').on('click', function(e) {\r\n    e.preventDefault();\r\n    const pageColorSwatches = jquery__WEBPACK_IMPORTED_MODULE_0___default()('.color-swatches-page');\r\n    const projects = pageColorSwatches.find('.card');\r\n\r\n    if (!running) {\r\n      running = true;\r\n      selection = jquery__WEBPACK_IMPORTED_MODULE_0___default()(this).data('group');\r\n      jquery__WEBPACK_IMPORTED_MODULE_0___default()('.color-swatch__category-buttons a').removeClass('active-tab');\r\n      jquery__WEBPACK_IMPORTED_MODULE_0___default()(this).addClass('active-tab');\r\n      filteredProjects = [];\r\n\r\n      for (var i = 0; i < projects.length; i++) {\r\n        var project = projects[i];\r\n        var dataString = jquery__WEBPACK_IMPORTED_MODULE_0___default()(project).data('groups');\r\n        var dataArray = dataString.split(',');\r\n\r\n        if (jquery__WEBPACK_IMPORTED_MODULE_0___default().inArray(selection, dataArray) > -1) {\r\n          jquery__WEBPACK_IMPORTED_MODULE_0___default()(project).addClass('setScale').queue(function(next) {\r\n            filteredProjects.push(project);\r\n            next();\r\n          }).queue(function(next) {\r\n            jquery__WEBPACK_IMPORTED_MODULE_0___default()(this).removeClass('setScale');\r\n            next();\r\n          }).queue(function(next) {\r\n            jquery__WEBPACK_IMPORTED_MODULE_0___default()(this).addClass('animating show')\r\n            next();\r\n          }).delay(750).queue(function() {\r\n            running = false;\r\n            jquery__WEBPACK_IMPORTED_MODULE_0___default()(this).removeClass('animating').dequeue();\r\n          });\r\n        } else {\r\n          jquery__WEBPACK_IMPORTED_MODULE_0___default()(project).queue(function(next) {\r\n            jquery__WEBPACK_IMPORTED_MODULE_0___default()(this).addClass('animating');\r\n            next();\r\n          }).queue(function(next) {\r\n            jquery__WEBPACK_IMPORTED_MODULE_0___default()(this).removeClass('show');\r\n            next();\r\n          }).delay(750).queue(function() {\r\n            jquery__WEBPACK_IMPORTED_MODULE_0___default()(this).removeClass('animating').dequeue();\r\n          });\r\n        }\r\n\r\n      }\r\n\r\n      buildGrid(filteredProjects);\r\n    }\r\n  })\r\n\r\n  function buildGrid(projects) {\r\n    var left = 15;\r\n    var top = 0;\r\n    var totalHeight = 0;\r\n    var largest = 0;\r\n    var heights = [];\r\n\r\n    for (var i = 0; i < projects.length; i++) {\r\n      jquery__WEBPACK_IMPORTED_MODULE_0___default()(projects[i]).css({\r\n        height: 'auto'\r\n      });\r\n      heights.push(jquery__WEBPACK_IMPORTED_MODULE_0___default()(projects[i]).height());\r\n    }\r\n\r\n    var maxIndex = 0;\r\n    var maxHeight = 0;\r\n\r\n    for (i = 0; i <= heights.length; i++) {\r\n      if (heights[i] > maxHeight) {\r\n        maxHeight = heights[i];\r\n        maxIndex = i;\r\n        jquery__WEBPACK_IMPORTED_MODULE_0___default()('.guide').height(maxHeight);\r\n      }\r\n\r\n      if (i === heights.length) {\r\n        for (i = 0; i < projects.length; i++) {\r\n          jquery__WEBPACK_IMPORTED_MODULE_0___default()(projects[i]).css({\r\n            position: 'absolute',\r\n            left: left + 'px',\r\n            top: top\r\n          });\r\n\r\n          if (jquery__WEBPACK_IMPORTED_MODULE_0___default()(window).width() < 768) {\r\n            left = left + jquery__WEBPACK_IMPORTED_MODULE_0___default()('.card').width() + 20;\r\n          }\r\n\r\n          else if (jquery__WEBPACK_IMPORTED_MODULE_0___default()(window).width() >= 768) {\r\n            left = left + jquery__WEBPACK_IMPORTED_MODULE_0___default()('.card').width() + 44;\r\n          }\r\n\r\n          if (i === maxIndex) {\r\n            jquery__WEBPACK_IMPORTED_MODULE_0___default()(projects[i]).css({\r\n              height: 'auto'\r\n            });\r\n          } else {\r\n            jquery__WEBPACK_IMPORTED_MODULE_0___default()(projects[i]).css({\r\n              height: maxHeight\r\n            });\r\n          }\r\n\r\n          if ((i + 1) % 3 === 0 && projects.length > 3 && jquery__WEBPACK_IMPORTED_MODULE_0___default()(window).width() < 768) {\r\n            top = top + jquery__WEBPACK_IMPORTED_MODULE_0___default()('.guide').height() + 20;\r\n            left = 15;\r\n            totalHeight = totalHeight + jquery__WEBPACK_IMPORTED_MODULE_0___default()('.guide').height() + 20;\r\n          } \r\n          else if ((i + 1) % 6 === 0 && projects.length > 6 && jquery__WEBPACK_IMPORTED_MODULE_0___default()(window).width() >= 768) {\r\n            top = top + jquery__WEBPACK_IMPORTED_MODULE_0___default()('.guide').height() + 20;\r\n            left = 15;\r\n            totalHeight = totalHeight + jquery__WEBPACK_IMPORTED_MODULE_0___default()('.guide').height() + 20;\r\n          } \r\n\r\n          jquery__WEBPACK_IMPORTED_MODULE_0___default()('#grid').height(totalHeight + jquery__WEBPACK_IMPORTED_MODULE_0___default()('.guide').height());\r\n        }\r\n      }\r\n    }\r\n  }\r\n})\n\n//# sourceURL=webpack://starter-theme/./src/scripts/templates/page.color-swatches.js?");

/***/ }),

/***/ "jquery":
/*!*************************!*\
  !*** external "jQuery" ***!
  \*************************/
/***/ ((module) => {

module.exports = jQuery;

/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			// no module.id needed
/******/ 			// no module.loaded needed
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = __webpack_modules__;
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/chunk loaded */
/******/ 	(() => {
/******/ 		var deferred = [];
/******/ 		__webpack_require__.O = (result, chunkIds, fn, priority) => {
/******/ 			if(chunkIds) {
/******/ 				priority = priority || 0;
/******/ 				for(var i = deferred.length; i > 0 && deferred[i - 1][2] > priority; i--) deferred[i] = deferred[i - 1];
/******/ 				deferred[i] = [chunkIds, fn, priority];
/******/ 				return;
/******/ 			}
/******/ 			var notFulfilled = Infinity;
/******/ 			for (var i = 0; i < deferred.length; i++) {
/******/ 				var [chunkIds, fn, priority] = deferred[i];
/******/ 				var fulfilled = true;
/******/ 				for (var j = 0; j < chunkIds.length; j++) {
/******/ 					if ((priority & 1 === 0 || notFulfilled >= priority) && Object.keys(__webpack_require__.O).every((key) => (__webpack_require__.O[key](chunkIds[j])))) {
/******/ 						chunkIds.splice(j--, 1);
/******/ 					} else {
/******/ 						fulfilled = false;
/******/ 						if(priority < notFulfilled) notFulfilled = priority;
/******/ 					}
/******/ 				}
/******/ 				if(fulfilled) {
/******/ 					deferred.splice(i--, 1)
/******/ 					var r = fn();
/******/ 					if (r !== undefined) result = r;
/******/ 				}
/******/ 			}
/******/ 			return result;
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/compat get default export */
/******/ 	(() => {
/******/ 		// getDefaultExport function for compatibility with non-harmony modules
/******/ 		__webpack_require__.n = (module) => {
/******/ 			var getter = module && module.__esModule ?
/******/ 				() => (module['default']) :
/******/ 				() => (module);
/******/ 			__webpack_require__.d(getter, { a: getter });
/******/ 			return getter;
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/define property getters */
/******/ 	(() => {
/******/ 		// define getter functions for harmony exports
/******/ 		__webpack_require__.d = (exports, definition) => {
/******/ 			for(var key in definition) {
/******/ 				if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
/******/ 					Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 				}
/******/ 			}
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/global */
/******/ 	(() => {
/******/ 		__webpack_require__.g = (function() {
/******/ 			if (typeof globalThis === 'object') return globalThis;
/******/ 			try {
/******/ 				return this || new Function('return this')();
/******/ 			} catch (e) {
/******/ 				if (typeof window === 'object') return window;
/******/ 			}
/******/ 		})();
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	(() => {
/******/ 		__webpack_require__.o = (obj, prop) => (Object.prototype.hasOwnProperty.call(obj, prop))
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/make namespace object */
/******/ 	(() => {
/******/ 		// define __esModule on exports
/******/ 		__webpack_require__.r = (exports) => {
/******/ 			if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 				Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 			}
/******/ 			Object.defineProperty(exports, '__esModule', { value: true });
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/jsonp chunk loading */
/******/ 	(() => {
/******/ 		// no baseURI
/******/ 		
/******/ 		// object to store loaded and loading chunks
/******/ 		// undefined = chunk not loaded, null = chunk preloaded/prefetched
/******/ 		// [resolve, reject, Promise] = chunk loading, 0 = chunk loaded
/******/ 		var installedChunks = {
/******/ 			"template.page.color-swatches": 0
/******/ 		};
/******/ 		
/******/ 		// no chunk on demand loading
/******/ 		
/******/ 		// no prefetching
/******/ 		
/******/ 		// no preloaded
/******/ 		
/******/ 		// no HMR
/******/ 		
/******/ 		// no HMR manifest
/******/ 		
/******/ 		__webpack_require__.O.j = (chunkId) => (installedChunks[chunkId] === 0);
/******/ 		
/******/ 		// install a JSONP callback for chunk loading
/******/ 		var webpackJsonpCallback = (parentChunkLoadingFunction, data) => {
/******/ 			var [chunkIds, moreModules, runtime] = data;
/******/ 			// add "moreModules" to the modules object,
/******/ 			// then flag all "chunkIds" as loaded and fire callback
/******/ 			var moduleId, chunkId, i = 0;
/******/ 			if(chunkIds.some((id) => (installedChunks[id] !== 0))) {
/******/ 				for(moduleId in moreModules) {
/******/ 					if(__webpack_require__.o(moreModules, moduleId)) {
/******/ 						__webpack_require__.m[moduleId] = moreModules[moduleId];
/******/ 					}
/******/ 				}
/******/ 				if(runtime) var result = runtime(__webpack_require__);
/******/ 			}
/******/ 			if(parentChunkLoadingFunction) parentChunkLoadingFunction(data);
/******/ 			for(;i < chunkIds.length; i++) {
/******/ 				chunkId = chunkIds[i];
/******/ 				if(__webpack_require__.o(installedChunks, chunkId) && installedChunks[chunkId]) {
/******/ 					installedChunks[chunkId][0]();
/******/ 				}
/******/ 				installedChunks[chunkId] = 0;
/******/ 			}
/******/ 			return __webpack_require__.O(result);
/******/ 		}
/******/ 		
/******/ 		var chunkLoadingGlobal = globalThis["webpackChunkstarter_theme"] = globalThis["webpackChunkstarter_theme"] || [];
/******/ 		chunkLoadingGlobal.forEach(webpackJsonpCallback.bind(null, 0));
/******/ 		chunkLoadingGlobal.push = webpackJsonpCallback.bind(null, chunkLoadingGlobal.push.bind(chunkLoadingGlobal));
/******/ 	})();
/******/ 	
/************************************************************************/
/******/ 	
/******/ 	// startup
/******/ 	// Load entry module and return exports
/******/ 	// This entry module depends on other loaded chunks and execution need to be delayed
/******/ 	var __webpack_exports__ = __webpack_require__.O(undefined, ["vendor"], () => (__webpack_require__("./src/scripts/templates/page.color-swatches.js")))
/******/ 	__webpack_exports__ = __webpack_require__.O(__webpack_exports__);
/******/ 	
/******/ })()
;